import { useContext, useCallback } from 'react';
import _get from 'lodash/get';
import _map from 'lodash/map';
import { formatListData, AjaxContext, AppContext } from 'commons-ui';

const useService = () => {
	const { postData, getData } = useContext(AjaxContext);
	const {
		app: { appName }
	} = useContext(AppContext);

	const getCsvDetails = useCallback(
		async ({ pageDetails, sortDetails, filterDetails }: { pageDetails: any; sortDetails: any; filterDetails: any }) => {
			const result = await postData({
				endpoint: '/marketing/dashboard/wallet/getCsvDetails',
				queryParams: {
					appName
				},
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails
				}
			});
			return {
				rowCount: _get(result, ['data', 'totalCount'], 0),
				data: formatListData(_get(result, ['data', 'csvDetails'], []))
			};
		},
		[]
	);

	const addCsvDetails = useCallback((wallet: any) => {
		return postData({
			endpoint: '/marketing/dashboard/wallet/addCsvDetails',
			body: wallet,
			queryParams: {
				appName
			}
		});
	}, []);

	const uploadCsvDetails = useCallback((formData: any) => {
		return postData({
			endpoint: '/marketing/dashboard/wallet/uploadCsv',
			body: formData,
			customHeaders: { 'Content-Type': 'multipart/form-data' },
			queryParams: {
				appName
			}
		});
	}, []);

	const addCoinsFromCsv = useCallback((walletId: string) => {
		return postData({
			endpoint: '/marketing/dashboard/wallet/addCoinsFromCsv',
			body: { _id: walletId },
			queryParams: {
				appName
			}
		});
	}, []);

	const getTransactionTypes = useCallback(async () => {
		return getData({
			endpoint: '/marketing/dashboard/wallet/getAccountingType',
			queryParams: {
				appName
			}
		});
	}, []);

	const getTransactionTypeOptions = useCallback(async () => {
		const transactionTypes = await getTransactionTypes();

		return _map(_get(transactionTypes, ['data', 'data'], []), (txnType: any) => ({
			id: txnType.typeBucket,
			label: `${txnType.typeNumber} - ${txnType.typeBucket}`
		}));
	}, []);

	return {
		getCsvDetails,
		addCsvDetails,
		addCoinsFromCsv,
		getTransactionTypeOptions,
		uploadCsvDetails
	};
};

export default useService;
